export const PASSWORD_CHANGE_SET = 'PASSWORD_CHANGE_SET'
export const PASSWORD_CHANGE_LOAD = 'PASSWORD_CHANGE_LOAD'
export const PASSWORD_CHANGE_SUCCESS = 'PASSWORD_CHANGE_SUCCESS'
export const PASSWORD_CHANGE_FAILED = 'PASSWORD_CHANGE_FAILED'
export const PASSWORD_CHANGE_CLEAR = 'PASSWORD_CHANGE_CLEAR'
